// @ts-check
// Páginas dos fluxos de automação, montadas por client/src/app/app.js (spec-2.0.0 seção 4.10, [FLX 20]; contrato 09 de
// fluxos, seção 17): a lista, a galeria de modelos, o editor (em modo foco, sem o menu; client/src/app/layout-mode.js)
// e as estatísticas.
import { html } from 'htm/preact';
import { FlowsPage } from './flows-page.js';
import { FlowTemplatesPage as FlowTemplatesGallery } from './flow-templates-page.js';
import { FlowEditorPage as FlowEditor } from './flow-editor-page.js';
import { FlowStatsPage as FlowStatistics } from './flow-stats-page.js';

/** Lista dos fluxos (/campaigns/flows). */
export function FlowListPage() {
  return html`<${FlowsPage} />`;
}

/** Galeria de modelos de fluxo (/campaigns/flows/templates). */
export function FlowTemplatesPage() {
  return html`<${FlowTemplatesGallery} />`;
}

/** Editor do fluxo (/campaigns/flows/:flowId?tab=editor|settings|exit). @param {{ flowId: string }} props */
export function FlowEditorPage({ flowId }) {
  return html`<${FlowEditor} flowId=${flowId} />`;
}

/** Estatísticas do fluxo (/campaigns/flows/:flowId/stats). @param {{ flowId: string }} props */
export function FlowStatsPage({ flowId }) {
  return html`<${FlowStatistics} flowId=${flowId} />`;
}
